<div class="mx-auto w-[90%]">
  <div class="mb-6 mt-10 flex justify-between text-center">
    <h1 class="text-start text-3xl font-bold">Crear Venta</h1>
    <div class="flex gap-4">
      <app-loading-button
        [text]="'Guardar'"
        [icon]="'save'"
        [loading]="isLoadingCrear"
        [disabled]="newVentaForm.invalid || newVentaForm.pending"
        (clicked)="mostrarDialogoCrear = true"
      />
    </div>
  </div>
  <form [formGroup]="newVentaForm" class="mx-auto mb-32 w-[100%] space-y-6">
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-2 text-xl font-semibold text-field-green">Datos Generales</h2>
      <div class="grid grid-cols-4 gap-4">
        <!-- EMPRESA FACTURADORA -->
        <div>
          <label for="empresaFacturadoraId" class="block text-sm font-medium">Empresa</label>
          <select
            id="empresaFacturadoraId"
            formControlName="empresaFacturadoraId"
            class="delay-50 border-1 form-select mt-1 block w-full rounded-md border-dark-blue shadow-sm transition ease-in focus:border-medium-green focus:ring focus:ring-medium-green focus:ring-opacity-50"
          >
            <option *ngFor="let empresa of empresasRefacturadoras" [value]="empresa.id">
              {{ empresa.nombreEmpresa }}
            </option>
          </select>
          <app-form-errors fieldName="empresaFacturadoraId" />
        </div>
        <div>
          <app-input-fecha
            [formGroup]="newVentaForm"
            controlName="fechaAsientoContable"
            label="Fecha del Asiento Contable"
          />
        </div>
      </div>
    </div>
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-2 text-xl font-semibold text-field-green">Observaciones</h2>
      <div class="grid grid-cols-1 gap-4">
        <app-input-textarea label="Observaciones del venta" [formGroup]="newVentaForm" controlName="observaciones" />
      </div>
    </div>
    <div class="card-shadow rounded-md p-4">
      <h2 class="mb-2 text-xl font-semibold text-field-green">Facturas Asociadas</h2>

      <!-- SELECTOR DE COLUMNAS-->
      <div class="relative mb-4 flex gap-4">
        <button
          (click)="toogleColumnDropdown()"
          class="btn flex items-center justify-center gap-2 rounded-lg border-2 border-medium-green bg-medium-green px-4 py-2 text-seasalt transition delay-100 ease-in hover:border-field-green hover:bg-seasalt hover:text-dark-blue"
        >
          {{ isColumnDropdownOpen ? 'Ocultar menú de columnas' : 'Mostrar menú de columnas' }}
        </button>
        <div *ngIf="isColumnDropdownOpen" class="dropdown-menu">
          <div
            *ngFor="let option of columnOptions"
            (click)="toggleColumnaSeleccionada(option)"
            [class.selected]="option.selected"
          >
            {{ option.headerName }}
          </div>
        </div>
      </div>

      <ag-grid-angular
        style="min-width: 100%; height: 75vh"
        class="ag-theme-quartz mx-auto"
        [rowData]="facturasParaVentaEnEfectivo"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
      />
    </div>
  </form>
</div>

<app-async-confirmation-dialog
  [isOpen]="mostrarDialogoCrear"
  [title]="'Crear venta'"
  [message]="'El asiento contable de venta será creado.'"
  [confirmButtonText]="'Crear Venta'"
  [confirmButtonIcon]="'check'"
  [loading]="isLoadingCrear"
  (closed)="mostrarDialogoCrear = false"
  (confirmed)="crearVentaEfectivo()"
/>
